import { render, staticRenderFns } from "./AccountAvaterComponent.vue?vue&type=template&id=7b5c4642&scoped=true&"
import script from "./AccountAvaterComponent.vue?vue&type=script&lang=js&"
export * from "./AccountAvaterComponent.vue?vue&type=script&lang=js&"
import style0 from "./AccountAvaterComponent.vue?vue&type=style&index=0&id=7b5c4642&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5c4642",
  null
  
)

export default component.exports